import React from 'react'
import './Footer.css'

const SOCIAL = [
   { label: 'Facebook', href: 'https://www.facebook.com/ETHOSTiyatroFestivali/', icon: 'fa-facebook' },
   { label: 'Twitter', href: 'https://twitter.com/ethos_festival', icon: 'fa-twitter' },
   { label: 'Instagram', href: 'https://www.instagram.com/ethosankara', icon: 'fa-instagram' },
]

export default function Footer() {
   return (
      <React.Fragment>
         <footer className='site-foot' lang='tr'>
            <div className='container site-foot-row'>
               <p className='site-foot-org'>
                  <strong>KÜSAGEM</strong>
                  <span>Yıldızevler Mahallesi 708. Sokak 23/1, Yıldız, Çankaya / Ankara</span>
               </p>
               <ul className='site-foot-social'>
                  {SOCIAL.map((item) => (
                     <li key={item.label}>
                        <a href={item.href} target='_blank' rel='noreferrer' aria-label={item.label}>
                           <i className={`fa ${item.icon}`} aria-hidden='true'></i>
                        </a>
                     </li>
                  ))}
               </ul>
               <p className='site-foot-meta'>
                  © {new Date().getFullYear()} Ethos
                  <span aria-hidden='true'> · </span>
                  Tasarım: <a href='https://genixo.ai' target='_blank' rel='noreferrer'>Genixo</a>
               </p>
            </div>
         </footer>
         <div className="BackTo">
            <a href="#" className="fa fa-angle-up" aria-label="Sayfanın başına dön"></a>
         </div>
      </React.Fragment>
   )
}
